import { $api } from "../../../../../services/request.config";
import { getActiveDelegationsActions } from "../getActiveDelegations.actions";

export const getActiveDelegationsThunkAction = () => async(dispatch) => {
    try {
        const response = await $api("v1/manager/substitutions");
        if(response.status === 200) {
            dispatch(getActiveDelegationsActions(response.data));
        }
    } catch (e) {
        // console.log(e);
        dispatch(getActiveDelegationsActions([]));

    }
};
